import axios from "axios";

let baseUrl = "/";


/**
 * 登录
 * @param params 参数
 * @returns 
 */
export const login = (params) => {
    return axios.post('/api/admin/login', params);
};

/**
 * 注册
 * @param params 参数
 * @returns 
 */
export const register = (params) => {
    return axios.post('/api/user/admin/register', params);
};


/**
 * 发送邮箱验证码
 * @param userId
 * @returns
 */
export const sendEmailCode = (userId) => {
    return axios.get('/api/admin/sendEmailCode?userId=' + userId );
};

/**
 * 单笔解析
 * @param params 参数
 * @returns 
 */
export const singleDealVideo = (params) => {
    return axios.post('/api/admin/singleDealVideo', params);
};


/**
 * 查询解析记录
 * @param params 参数
 * @returns 
 */
export const getRecord = (params) => {
    return axios.post('/api/admin/getRecord', params);
};




